const removePunctuation = (puncString) => {
    return puncString?.replace(/[^\p{L}\p{N}\s]/gu, '')?.replace(/  +/g, ' ');
};

export default removePunctuation;
